import React, { useEffect, useRef } from "react";
import "ol/ol.css";
import { Map, View } from "ol";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { fromLonLat } from "ol/proj";
import { Feature } from "ol";
import { Point } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Style, Icon } from "ol/style";
import Overlay from "ol/Overlay";
import "./TimeZonesWorldMap.css";
import bc from "./images/BookCover.png"
import decorate from "./images/compass.png"

const TimeZonesWorldMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const locations = [
      {
        name: "Seattle",
        coords: [-122.335167, 47.608013],
        info: "Where I am currently studying for my master's degree",
      },
      {
        name: "San Francisco",
        coords: [-122.419418, 37.774929],
        info: "Where the server is hosted",
      },
      {
        name: "Shanghai",
        coords: [121.473701, 31.230416],
        info: "My hometown",
      },
      {
        name: "Fullerton, CA",
        coords: [-117.924301, 33.870365],
        info: "Where I studied for a bachelor's degree in CS",
      },
    ];

    const features = locations.map((loc) => {
      const feature = new Feature({
        geometry: new Point(fromLonLat(loc.coords)),
        name: loc.name,
      });
      feature.setStyle(
        new Style({
          image: new Icon({
            src: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
            scale: 0.05,
          }),
        })
      );
      return feature;
    });

    const vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: features,
      }),
    });

    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        vectorLayer,
      ],
      view: new View({
        center: fromLonLat([-122.419418, 37.774929]),
        zoom: 4.5,
      }),
    });

    // Add overlays for city names and information
    locations.forEach((loc) => {
      const overlay = new Overlay({
        position: fromLonLat(loc.coords),
        element: document.createElement("div"),
      });
      overlay.getElement().className = "map-label";
      overlay.getElement().innerHTML = `<b>${loc.name}</b><br>${loc.info}`;
      map.addOverlay(overlay);
    });

    return () => map.setTarget(null);
  }, []);

  return (
    <div className="section num5" id="time-zones-world-map">
      <h2 className="TZTitle">Server And locations</h2>
      <div className="mapbg">
        <div ref={mapRef} className="map-container"></div>
        <img src={decorate} alt="decorate" className="decorate-image" />
      </div>
      <div class="TZcard">
        <div class="TZimgBox">
          <div class="TZbark"></div>
          <img src= {bc} alt="bookcover" className="bookcover"></img>
        </div>
        <div class="TZdetails">
          <h4>Login User features:</h4>
          <p>Weather Query</p>
          <p>Technology News Browsing</p>
          <p>XU's leetcode problem notes</p>
          <p>XU's movie sharing</p>
          <h4>Server maintenance date:</h4>
          <p>Every Saturday: 1PM to 3PM</p>
          <p>For debugging and upgrading</p>
          <h4>Study locations:</h4>
          <p>Fullerton and Seattle</p>
          <p>For Undergraduate and Master</p>
          <h4>Server location:</h4>
          <p>San Francisco, CA</p>

          <p>♥Zhihui XU</p>
        </div>
      </div>
    </div>
  );
};

export default TimeZonesWorldMap;
